export default __webpack_public_path__ + "images/DL.7255280.png";